import React from 'react';

function Pagination(props) {
	let {
		total,
		limit,
		currentPage
	} = props;
	let maxPage = Math.ceil(total / limit);

	if (maxPage <= 1) {
		return (null);
	}

	const getPagesRange = (c, m) => {
		var current = c,
			last = m,
			delta = 2,
			left = current - delta,
			right = current + delta + 1,
			range = [],
			rangeWithDots = [],
			l;

		for (let i = 1; i <= last; i++) {
			if ((i === 1 || i === last) || (i >= left && i < right)) {
				range.push(i);
			}
		}

		for (let i of range) {
			if (l) {
				if (i - l === 2) {
					rangeWithDots.push(l + 1);
				} else if (i - l !== 1) {
					rangeWithDots.push('...');
				}
			}
			rangeWithDots.push(i);
			l = i;
		}

		return rangeWithDots;
	}

	let pages = getPagesRange(currentPage, maxPage);

	return (
		<nav>
			<ul className="pagination">
				<li className={'page-item' + (currentPage === 1 ? ' disabled' : '')}>
					<a className="page-link" href="#" onClick={() => {
						if (currentPage !== 1) {
							props.changePage(currentPage - 1);
						}
					}}
					   tabIndex="-1" aria-disabled="true">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
						     stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
						     className="cs-icon cs-icon-chevron-left">
							<path
								d="M13 16L7.35355 10.3536C7.15829 10.1583 7.15829 9.84171 7.35355 9.64645L13 4"></path>
						</svg>
					</a>
				</li>
				{pages.map((number, index) => {
					return (
						<li
							key={'page' + index}
							className={'page-item' + ((number) === props.currentPage ? ' active' : '')}
							onClick={() => {
								if (number !== '...') {
									props.changePage(number);
								}
							}}
						>
							{number !== '...' && (<span className="page-link">{(number)}</span>)}
							{number === '...' && (<span className="page-link">{(number)}</span>)}
						</li>
					);
				})}
				<li className={'page-item' + (currentPage === maxPage ? ' disabled' : '')}>
					<a className="page-link" href="#" onClick={() => {
						if (currentPage !== maxPage) {
							props.changePage(currentPage + 1);
						}
					}}>
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
						     stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
						     className="cs-icon cs-icon-chevron-right">
							<path d="M7 4L12.6464 9.64645C12.8417 9.84171 12.8417 10.1583 12.6464 10.3536L7 16"></path>
						</svg>
					</a>
				</li>
			</ul>
		</nav>
	);
}

export default Pagination;
